import { useCodePipelinesQuery } from './useCodePipelinesQuery';
import { useCodePipelinesSearch } from './useCodePipelinesSearch';

export const useCodePipelines = () => {
    const query = useCodePipelinesQuery();
    const { keyword } = useCodePipelinesSearch();

    const items = query.data?.pages?.flatMap(page =>
        (page && 'items' in page) ? page.items : []
    ) ?? [];

    const visibleItems = items.filter(item =>
        !keyword ||
        item.name?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.cloudFormationStackName?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.lastExecutionStatus?.toLowerCase().includes(keyword.toLowerCase())
    );

    const fetchNextPage = () => {
        if (query.hasNextPage) {
            query.fetchNextPage();
        }
    };

    return {
        items,
        visibleItems,
        loading: query.isLoading,
        nextToken: query.hasNextPage ? 'has-more' : null,
        fetchNextPage,
    };
};
